import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum";
import { defineResources } from "jadro-pico-app/Resources/defineResources";

export const UserProfileResources = defineResources({
  [LanguageEnum.CS]: {
    sectionTitle: "Chlast Pičo Profil",
    fieldWeight: "Hmotnost (kg)",
    weightRangeError: "Zadejte hmotnost mezi 30 a 300 kg",
    operationLabel: "Uložení profilu",
    saveSubmitted: "Změny profilu odeslány",
  },
  [LanguageEnum.EN]: {
    sectionTitle: "Chlast Pičo Profile",
    fieldWeight: "Weight (kg)",
    weightRangeError: "Enter a weight between 30 and 300 kg",
    operationLabel: "Profile save",
    saveSubmitted: "Profile changes submitted",
  },
});
